export default "__VITE_ASSET__afed4f0f__"